import { computed } from 'vue';
import { useAuthStore } from '@/stores/authStore';

export function useCompanyCurrency() {
    const authStore = useAuthStore();

    const currency = computed(() => authStore.user?.company_currency ?? 'CZK');
    const locale = computed(() => {
        const loc = authStore.user?.company_locale;
        if (loc === 'en') {
            return 'en-US';
        }
        if (loc === 'ro') {
            return 'ro-RO';
        }
        if (loc === 'sk') {
            return 'sk-SK';
        }

        return 'cs-CZ';
    });

    return { currency, locale };
}
